module.exports = __webpack_public_path__ + "h5/img/childCompanyDetail_bg_img.161ca0a1.png";